import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Table Row",
  category: "layouts",
  description: "A simple table block",
  icon: "editor-indent",
  flags: {
    contentWidth: true,
  },
}

export default defineBlock("content/table-row", (props) => {
  return (
    <div className="flex flex-col sm:flex-row table-block-row gap-1 border-b border-bg-mid py-4 md:py-3">
      <div className="type-label-m table-block-col">
        <EditableText
          store="key"
          as="div"
          placeholder="Enter some text"
          appendOnEnter="content/table-row"
          removeOnDelete
        />
      </div>
      <div className="type-label-m table-block-col text-fg-secondary mt-2 sm:mt-0 subtle-text-styles">
        <EditableText store="value" as="div" placeholder="Enter some text" appendOnEnter="content/table-row" />
      </div>
    </div>
  )
})
